// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront13 from "pages/Servicii/ServiciiSpeciale/CuratenieDupaEvenimente/sections/sections/images/bgFront13.webp";
import bgBack13 from "pages/Servicii/ServiciiSpeciale/CuratenieDupaEvenimente/sections/sections/images/bgBack13.webp";

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid
                    container
                    item
                    spacing={4}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ textAlign: "center" }}
                >
                    {/* ROTATING CARD */}
                    <Grid item xs={12} lg={4} sx={{ mx: "auto" }} spacing={2}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgFront13}
                                icon="storefront"
                                title={
                                    <>
                                        Curățenie după
                                        <br />
                                        Evenimente
                                    </>
                                }
                                description="Experiență, tehnologie și personal instruit – curățenie impecabilă pentru spații comerciale cu trafic intens."
                            />
                            <RotatingCardBack
                                image={bgBack13}
                                title="Calitate vizibilă, eficiență constantă"
                                description="Contactează-ne pentru o ofertă personalizată și consultanță gratuită."
                                action={{
                                    type: "internal",
                                    route: "/contact-curatenie",
                                    label: "cere o ofertă",
                                }}
                            />
                        </RotatingCard>
                    </Grid>

                    {/* 6 INFO CARDS */}
                    <Grid item xs={12} lg={7} sx={{ textAlign: "center" }} ml={6}>
                        <Grid
                            container
                            spacing={3}
                            sx={{ mt: { xs: 0, md: 6 } }}
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                        >
                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="event"
                                    title="Curățenie pre-eveniment"
                                    description="Asigurăm pregătirea completă a spațiului pentru evenimente, expoziții sau târguri, prin servicii de curățenie generală și organizare eficientă, menite să creeze un mediu impecabil și primitor."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="support_agent"
                                    title="Asistență permanentă pe durata evenimentului"
                                    description="Asigurăm suport operațional continuu pe toată durata evenimentului, prin echipe dedicate, pregătite să intervină prompt și discret ori de câte ori este necesar."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="event_busy"
                                    title="Curățenie post-eveniment"
                                    description="La finalul evenimentului, ne ocupăm de curățenia completă și readucem spațiul la starea inițială."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="delete"
                                    title="Colectare și degajare deșeuri"
                                    description="Colectare și evacuare deșeuri
Ne ocupăm de strângerea, sortarea și eliminarea deșeurilor într-un mod sigur, curat și conform reglementărilor de mediu.
"
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="star"
                                    title="Calitate garantată & discreție"
                                    description="Calitate garantată și discreție
Echipă calificată, monitorizare continuă, echipamente moderne și soluții profesionale ce asigură un mediu curat și plăcut.."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="celebration"
                                    title="Experiență în evenimente majore"
                                    description="Experiență în evenimente de anvergură
Am oferit servicii de curățenie la evenimente importante precum IRB Nations Cup, EXPO Make-Up, precum și concertele artiștilor Sting și Cesaria Evora."
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
